export default __webpack_public_path__ + "static/media/oyin.e6d02de6.png";